import { IconPlus } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { IconButton } from "../../../mantine/components/IconButton/IconButton";
import type { Doc } from "../../DeliveryOverview/DeliveryOverview.types";

export function getGenerateInvoiceColumn(
  canGenerate: boolean,
  onGenerateInvoice: (document: Doc) => void
): MRT_ColumnDef<Doc> {
  return {
    id: "generate_invoice",
    header: "",
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ row }) => {
      if (row.original.documentType !== "draft") {
        return null;
      }

      const button = (
        <IconButton
          color="primary"
          icon={IconPlus}
          loading={!canGenerate}
          size="xs"
          variant="outline"
          onClick={() => onGenerateInvoice(row.original)}
        >
          Erstellen
        </IconButton>
      );

      return button;
    }
  };
}
